import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { HomeService } from 'src/app/features/home/home.service';

@Component({
  selector: 'app-mp-card-details',
  templateUrl: './mp-card-details.component.html',
  styleUrls: ['./mp-card-details.component.scss']
})
export class MpCardDetailsComponent implements OnInit, OnDestroy {
  mpCards = {
    'upmc-health-plan-imp-notices': '152a5fc5-0d28-4c9d-976f-81f489a337cc',
    'pharmacy-updates': 'db2e9a65-f3f5-4a7f-af73-e33da7f55a7a',
    'education-webinars': '3bc54c22-6a04-48c2-928e-2f42334fa0a4',
    'new-with-Upmc': '78d1e6e9-113c-4f0e-9063-33f522b8a694'
  };
  mpContent;
  hasError: boolean;
  selectedCard: string;
  isLoading: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(private route: ActivatedRoute, private homeService: HomeService) {}

  ngOnInit() {
    this.selectedCard = this.route?.snapshot?.url[0]?.path;
    this.getCardDetails(this.mpCards[this.selectedCard]);
  }

  getCardDetails(id) {
    this.isLoading = true;
    this.homeService
      .getMpCardDetails(id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.mpContent = res[0]?.value;
          this.isLoading = false;
          console.log(res);
        },
        error: (error) => {
          if (error) {
            this.hasError = true;
            this.isLoading = false;
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.hasError = false;
  }
}
